function zp(s) {
  // zero padding for data fixes
  return `0${s}`.slice(-2);
}

function addMinutes(dt, minutes) {
  dt.setTime(dt.getTime() + minutes * 60 * 1000);
  return dt;
}

function datetimeobjToIcalDate(dt) {
  // ical date time is not ISO! https://www.kanzaki.com/docs/ical/dateTime
  // 2019-01-01 --> 20190101 ...
  return `${dt.getFullYear()}${zp(dt.getMonth() + 1)}${zp(dt.getDate())}T${zp(
    dt.getHours()
  )}0000Z`;
}

function buildIsoDate(d) {
  if (typeof d === "string") {
    if (d.indexOf("Z") === d.length - 1) {
      const dt = new Date(d);
      const offsetMinutes = dt.getTimezoneOffset();
      return datetimeobjToIcalDate(addMinutes(dt, offsetMinutes));
    }

    // if (d.indexOf('T') !== -1 && d.indexOf('Z') !== -1) {
    //   return d;
    // }

    const offset = `0${new Date().getTimezoneOffset() / 60}`.slice(-2);

    // eslint-disable-next-line no-useless-escape
    return `${d.replace(/\-/g, "")}T${offset}0000Z`;
  }
  return datetimeobjToIcalDate(d);
}

export default function buildIcalDownloadUrl({
  name,
  description,
  location,
  dateStart,
  dateEnd,
  url,
}) {
  const now = new Date();

  const DTSTART = buildIsoDate(dateStart);
  const DTEND = buildIsoDate(dateEnd || dateStart);

  const ics_lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:Microsoft Exchange Server 2010",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:event-${now.getTime()}@insolvenzbekanntmachungen.de`,
    `DTSTAMP:${buildIsoDate(now)}`,
    `DTSTART:${DTSTART}`,
    `DTEND:${DTEND}`,
    `DESCRIPTION:${description.replace(/(\r\n|\n|\r)/gm, "\\n")}`,
    `SUMMARY:${name}`,
    `URL:${url}`,
  ];
  if (location) {
    ics_lines.push(`LOCATION:${location}`);
  }
  const all_ics_lines = ics_lines.concat([
    `LAST-MODIFIED:${buildIsoDate(now)}`,
    "SEQUENCE:0",
    "END:VEVENT",
    "END:VCALENDAR",
  ]);
  const res = `data:text/calendar;base64,${btoa(
    unescape(encodeURIComponent(all_ics_lines.join("\r\n")))
  )}`;
  return res;
}
